export default {
	path: '/object-warn-work-occur-statistic-bar',
	redirect: '/object-warn-work-occur-statistic-bar',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'ObjectWarnWorkOccurStatisticBarHome',
			component: () => import('@/views/biz/ObjectWarnWorkOccurStatisticBar'),
		},
	],
};
